import React, { useContext, useState } from "react";
import { ModalContext } from "../../context/ModalContext";

// Two-step delete confirmation: first OK, then a required comment (saved with
// the deletion in the historial and the bitácora of the obra).
const ConfirmarEliminacion = ({ mensaje, requiereComentario, onConfirm }) => {
  const [paso, setPaso] = useState("confirmar");
  const [comentario, setComentario] = useState("");

  const { clearModal } = useContext(ModalContext);

  const handleOk = () => {
    if (requiereComentario) return setPaso("comentario");
    onConfirm();
    clearModal();
  };

  const handleEliminar = (e) => {
    e.preventDefault();
    const texto = comentario.trim();
    if (texto === "") return;
    onConfirm(texto);
    clearModal();
  };

  if (paso === "comentario") {
    return (
      <form onSubmit={handleEliminar}>
        <p>{mensaje}</p>
        <label className="form-label bold">Motivo de la eliminación</label>
        <textarea
          rows={3}
          autoFocus
          value={comentario}
          className="form-control mb-3"
          placeholder="Escribe un comentario (obligatorio)"
          onChange={(e) => setComentario(e.target.value)}
        />
        <div className="row">
          <div className="col-6">
            <button
              type="button"
              className="btn w-100 text-muted"
              onClick={clearModal}
            >
              Cancelar
            </button>
          </div>
          <div className="col-6">
            <button
              type="submit"
              className="btn btn-danger w-100"
              disabled={comentario.trim() === ""}
            >
              Eliminar
            </button>
          </div>
        </div>
      </form>
    );
  }

  return (
    <div>
      <p>{mensaje}</p>
      <div className="row">
        <div className="col-6">
          <button
            type="button"
            className="btn w-100 text-muted"
            onClick={clearModal}
          >
            Cancelar
          </button>
        </div>
        <div className="col-6">
          <button type="button" className="btn btn-primary w-100" onClick={handleOk}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmarEliminacion;
